module.exports = __webpack_public_path__ + "img/Dantam Fashion 04.fd5eb7fb.jpg";